import storage from 'didi-store'
import { isObject } from 'lodash'
import store from '../../store'
import { getSodaGlobalParams } from '@/common/utils/bridge'
import { getOSInfo, IsMobileBased, isFlutterEnv, isLocal, isSim } from '@/common/utils/env'
import { getBDCountry } from './i18n'
const isPro = process.env.NODE_ENV === 'production'
const OS_TYPE_JSON = {
  window: 9,
  mac: 10,
  android: 2,
  ios: 1,
  default: -1,
}

let appVersion = ''

// 获取app版本号，缓存不用每次omega trackEvent时调用bridge方法
async function getAppVersion() {
  if (appVersion) {
    return appVersion
  }
  try {
    const globalParams = await getSodaGlobalParams()
    appVersion = globalParams?.appVersion || ''
  } catch (e) {
    if (IsMobileBased() || isFlutterEnv()) {
      // 正式手机环境才报错
      console.error(e)
    }
  }
  return appVersion
}

function IsPC() {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

export async function getUserName() {
  const userInfo = store.state.login.userInfo || {}
  const userName = userInfo.username || storage.get('uname') || ''
  return userName
}

const isPCFlag = IsPC()
export async function trackEvent(eventId, attrs) {
  const userInfo = store.state.login.userInfo || {}
  const userName = userInfo.username || storage.get('uname') || ''
  // const geo = store.state.geo || {}
  const areaGroup = store.getters.areaGroup || {}

  const version = await getAppVersion()
  let explorer = 1
  if (!version) {
    explorer = isPCFlag ? 0 : 2
  }

  const user = {
    name: userName,
    email: userInfo.email || '',
    dept: userInfo.dept || '',
    job: userInfo.job || '',
    locale: userInfo.locale || '',
    country: userInfo.country || '',
    userName,
  }
  const attachInfo = {
    // 设备和业务信息 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=272905834
    osType: OS_TYPE_JSON[getOSInfo() || 'default'],
    businessType: 4, // 内部业务类型 1:r, 2:c, 3:b, 4:bd, 5:m
    brand: 2, // 外卖品牌类型 1:滴滴外卖，2:didi Food，3:99 Food
    terminalType: 1, // 端类型信息 1：独立端 5：web
  }
  window.Omega.setUserName(userName)
  // 控制台报已经删除该api
  // window.Omega.setLocation(geo.lng, geo.lat)
  window.Omega.setCityId(areaGroup.cityId)
  window.Omega.setConfig({
    locale: userInfo.locale,
    countyId: userInfo.country || getBDCountry(),
    userName,
    userId: userName,
    attrs: {
      explorer,
    },
  })

  if (window.Omega && isPro && !isSim && !isLocal) {
    // 增加描述，兼容天眼埋点
    window.Omega.trackEvent(eventId, `发送Omega埋点: ${eventId}`, {
      terminal: 'app',
      appVersion: version || '',
      country: userInfo.country || getBDCountry(),
      user,
      ...attachInfo,
      ...attrs,
      explorer,
    })
  }
}

/**
 * 自定义错误埋点方法，主要用于技术埋点
 * 配置参考：https://cooper.didichuxing.com/knowledge/share/page/LbZA8PLmKL78?base=cRkmiByBnrTe
 */
export function trackError(errMsg, code, attrs) {
  if (window.Omega && isPro) {
    if (isObject(code)) {
      ;[attrs, code] = [code, attrs]
    }
    window.Omega.trackError('OMGH5Error', code || 'tech error', errMsg, attrs)
  }
}
